// src/app/store.js
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer }   from "redux-persist";
import storage                            from "redux-persist/lib/storage";

import authReducer        from "../features/authSlice";
import roundReducer       from "../features/roundSlice";
import { chatReducer }    from "../features/chatSlice";
import transactionReducer from "../features/transactionSlice";
import pointsReducer      from "../features/pointsSlice";          // <-- NEW

// Remove the legacy persisted auth state that contained JWTs.
if (typeof window !== "undefined") {
  window.localStorage.removeItem("persist:root");
  window.localStorage.removeItem("authUser");
}

/* ------------------------------------------------------------------ */
/* 🔒 Persist configuration                                           */
/* ------------------------------------------------------------------ */
const persistConfig = {
  key: "secure-root",
  storage,
  whitelist: [],
};

/* ------------------------------------------------------------------ */
/* 🧩 Combine all slice reducers                                      */
/* ------------------------------------------------------------------ */
const appReducer = combineReducers({
  auth        : authReducer,
  round       : roundReducer,
  chat        : chatReducer,
  transaction : transactionReducer,
  points      : pointsReducer,     // <-- REGISTERED HERE
});

/* ------------------------------------------------------------------ */
/* 🌟 Root reducer – resets state on logout                           */
/* ------------------------------------------------------------------ */
const rootReducer = (state, action) => {
  if (action.type === "auth/logout") {
    state = undefined;             // purge redux (persist will follow)
  }
  return appReducer(state, action);
};

/* ------------------------------------------------------------------ */
/* 🏗️  Store + Persistor                                             */
/* ------------------------------------------------------------------ */
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,    // keep your original setting
    }),
});

export const persistor = persistStore(store);
export default store;

